import { makeStyles } from "@material-ui/core";

export const TooltipULStyles = makeStyles({
    root: {
        padding: "10px 0 5px 0",
        positon: "relative",
        '& li': {
            fontSize: 14,
            marginBottom: 10,
            whiteSpace: "nowrap"
        }
    },
});